import React, { useState, useEffect } from 'react';
import '../css/InventoryCheck.css';

const InventoryCheck = () => {
    const [inventory, setInventory] = useState([]);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        fetchInventory();
    }, []);

    const fetchInventory = () => {
        fetch(`${API_BASE_URL}/check_inventory`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            }
        })
        .then(response => response.json())
        .then(data => {
            setInventory(data);
        })
        .catch(error => console.error('Error fetching inventory:', error));
    };

    const handleInputChange = (e, index, field) => {
        const updatedInventory = [...inventory];
        updatedInventory[index][field] = e.target.value;
        setInventory(updatedInventory);
    };

    const handleSaveInventory = () => {
        const formattedInventory = inventory.map(item => ({
            product_id: item.id,
            used_today: parseInt(item.used_today, 10) || 0,
        }));

        fetch(`${API_BASE_URL}/save_inventory_check`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({ inventory: formattedInventory })
        })
        .then(response => response.json())
        .then(data => {
            alert(data.message);
            fetchInventory();
        })
        .catch(error => console.error('Error saving inventory:', error));
    };

    const downloadCSV = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/export_inventory_csv`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                }
            });
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'inventory.csv';
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            console.error('Error downloading CSV:', error);
        }
    };

    const downloadExcel = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/export_inventory_excel`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                }
            });
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'inventory.xlsx';
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            console.error('Error downloading Excel:', error);
        }
    };

    return (
        <div className="inventory-container">
            <h2>Inventory Check</h2>
            <div className="export-buttons">
                <button onClick={downloadCSV}>Download CSV</button>
                <button onClick={downloadExcel}>Download Excel</button>
            </div>
            <div className="inventory-grid">
                {inventory.map((item, index) => (
                    <div key={item.id} className="inventory-card">
                        <div className="card-header">
                            <img
                                src={item.image || 'placeholder.png'}
                                alt={item.name}
                                className="product-image"
                            />
                        </div>
                        <div className="card-body">
                            <h3 className="product-name">{item.name}</h3>
                            <div className="inventory-info">
                                <p><strong>Product ID:</strong> {item.id}</p>
                                <p><strong>Previous Quantity:</strong> {item.previous_quantity ?? 'N/A'}</p>
                                <p><strong>Current Quantity:</strong> {item.quantity ?? 'N/A'}</p>
                                <p><strong>Price:</strong> {item.price ? `$${item.price}` : 'N/A'}</p>
                                <div className="progress-container">
                                    <div className="progress-bar" style={{width: `${item.quantity}%`}}></div>
                                </div>
                                <div className="used-today">
                                    <label htmlFor={`usedToday-${item.id}`}>Used Today</label>
                                    <input
                                        type="number"
                                        id={`usedToday-${item.id}`}
                                        value={item.used_today || ''}
                                        onChange={(e) => handleInputChange(e, index, 'used_today')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <button className="save-button" onClick={handleSaveInventory}>Save Inventory</button>
        </div>
    );
};

export default InventoryCheck;
